<h5>
    {{ "CampEnrollment.soldCount" | translate }}
    @if (nothingSold) {
        <span
            >:
            <span
                translate="CampEnrollment.soldCountValue"
                [translateParams]="{
                    soldCount: daysVariant.soldCount,
                    capacity: getCapacity(),
                }"
                ></span
            ></span
        >
    }
</h5>

@if (!nothingSold) {
    <div class="progress">
        <div
            class="progress-bar bg-success"
            role="progressbar"
            [ngStyle]="{ width: percentOfCapacity + '%' }"
        >
            <span
                translate="CampEnrollment.soldCountValue"
                [translateParams]="{
                    soldCount: daysVariant.soldCount,
                    capacity: getCapacity(),
                }"
                ></span
            >
        </div>
    </div>
}

@if (!nothingSold) {
    <div>
        <h5 class="voffset-20">{{ "CampEnrollment.campers" | translate }}</h5>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                        {{ "CampEnrollment.fullName" | translate }}
                    </th>
                    <th scope="col">
                        {{ "CampEnrollment.dateOfBirth" | translate }}
                    </th>
                    <th scope="col">
                        {{ "CampEnrollment.ageAtSessionStartDate" | translate }}
                    </th>
                    <th scope="col">
                        {{ "CampEnrollment.gender" | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (
                    child of daysVariant.campers;
                    track child;
                    let i = $index
                ) {
                    <tr>
                        <th scope="row">{{ i + 1 }}</th>
                        <td>{{ child.fullName }}</td>
                        <td>{{ child.dateOfBirth | bcDate }}</td>
                        <td>{{ child.ageInMonthsOnStartDate | age }}</td>
                        <td>{{ child.gender }}</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
}
